import { Grid } from "@mui/material";
import { Talent } from "../../talents/talentAPI";
import TalentCustomerRecruit from "./talentCustomerRecruit/TalentCustomerRecruit";
import TalentEezyWorkExperience from "./TalentEezyWorkExperience";
import TalentHrTasks from "./TalentHrTasks";
import TalentIntroducedToCustomer from "./talentSkillSet/talentIntroducedToCustomer/TalentIntroducedToCustomer";
import TalentSkillSet from "./talentSkillSet/TalentSkillSet";
import TalentUpcomingWork from "./TalentUpcomingWork";
import TalentBasicInfo from "./talentBasicInfo/TalentBasicInfo";

type Props = {
  talent: Talent;
};

const TalentProfileSummary = ({ talent }: Props) => {
  return (
    <Grid item container xs={9} spacing={2}>
      <Grid item xs={6.5}>
        <TalentBasicInfo talent={talent} />
        <TalentSkillSet talent={talent} />
        <TalentEezyWorkExperience />
      </Grid>
      <Grid item xs={5.5}>
        <TalentUpcomingWork />
        <TalentIntroducedToCustomer talent={talent} />
        <TalentHrTasks talent={talent} />
        <TalentCustomerRecruit talent={talent} />
      </Grid>
    </Grid>
  );
};

export default TalentProfileSummary;
